<template lang="pug">
  section.division-item
    v-card-title
      v-layout(justify-center)
        div(class="mr-3")
          v-btn(icon,
            @click="$router.go(-1)")
            v-icon(color="primary", large) arrow_back
        v-layout(column style="transform: translateX(-30px)")
          h3(class="pb-2") {{ organisationName }}
          h6(class="title grey--text text-xs-center") {{ divisionName }}
    v-card-text
      v-layout(row justify-center).pb-4
        v-flex(xs11)
          v-tabs(v-model="tab" slider-color="primary")
            v-spacer
            v-tab(key="divisions") Подразделения
            v-tab(key="positions") Должности
            v-btn(v-if="tab === 0", color="primary", @click="").ml-5
              v-icon.mr-2 add
              span Добавить
            v-btn(v-else color="success", @click="addPosition").ml-5
              v-icon.mr-2 add
              span Добавить
            v-spacer
            v-tab-item(key="divisions")
              DivisionsItemTable(:divisionId="id")
            v-tab-item(key="positions")
              PositionsItemTable(:divisionId="id")
</template>

<script>
import DivisionsItemTable from './DivisionItemTable/DivisionItemTable'
import PositionsItemTable from '../../Position/PositionItemTable/PositionItemTable'
export default {
  name: 'DivisionItem',
  components: { PositionsItemTable, DivisionsItemTable },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    tab: 1
  }),
  computed: {
    organisationName() {
      return this.$store.state.organisation.organisationItem.name
    },
    divisionName() {
      return this.$store.state.organisation.divisionItem.name
    }
  },
  methods: {
    addPosition() {
      this.$router.push({ path: '/main/organisation/division/position/add' })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganisationStructure/Division/DivisionItem/DivisionItem.vue